import React, { useState } from "react";
import { Box } from "../../../components/styled/Elements";
import {
  PaginationContainer,
  TableWrapper,
} from "../../../components/common/tables/ListTable";
import { receivedReqColumns } from "../../../helpers/adminConstants/TableConstants";
import ReasonModal from "../../../components/admin/Modals/ReasonModal/ReasonModal";
import { useTranslation } from "react-i18next";
import Pagination from "react-js-pagination";
import { NoRecord } from "../../../components/admin/NoRecord/NoRecord";

const ReceivedRequests = ({
  receivedReqsRows,
  totalCount,
  perPage,
  activePage,
  setActivePage,
  acceptRejectRequest,
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [reason, setReason] = useState("");
  const handleReasonChange = (e) => {
    const { value } = e.target;
    setReason(value);
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  return (
    <Box>
      <TableWrapper>
        <Box className="table-responsive custom-scroll overflow-x-auto">
          <table className="w-100 ">
            <thead>
              <tr>
                {receivedReqColumns.map((col, key) => (
                  <th key={key} className="text-nowrap">
                    {t(col.label)}
                  </th>
                ))}
              </tr>
            </thead>
            {receivedReqsRows && receivedReqsRows.length > 0 ? (
              <tbody>
                {receivedReqsRows?.map((row, index) => (
                  <tr key={index}>
                    {receivedReqColumns?.map((col, key) => (
                      <td key={key}>
                        {col.render
                          ? col.render(
                              row[col.name],
                              row,
                              t,
                              setShowModal,
                              acceptRejectRequest,
                              setRequestId
                            )
                          : col.name === "id"
                          ? (activePage - 1) * perPage + index + 1
                          : row[col.name]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="100%">
                    <NoRecord />
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </Box>
        {totalCount && (
          <PaginationContainer>
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              activePage={activePage}
              itemsCountPerPage={perPage}
              totalItemsCount={totalCount}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              // getPageUrl={(pageNumber) => pageHrefs[pageNumber - 1]}
            />
          </PaginationContainer>
        )}
      </TableWrapper>
      <ReasonModal
        acceptRejectRequest={acceptRejectRequest}
        requestId={requestId}
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setReason(null);
        }}
        onChange={handleReasonChange}
        reason={reason}
      />
    </Box>
  );
};

export default ReceivedRequests;
